import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';
import { Check, Copy, Loader2, Save } from 'lucide-react';
import { NoteToolbarControls } from './NoteToolbarControls';
import { noteToolbarActionsClasses, noteToolbarClasses, noteToolbarTemplateClasses } from './noteInstructions.styles';
import type { NoteToolbarActionsProps, NoteToolbarProps } from './noteInstructions.types';

const NoteSaveCopy = ({ onSave, isSaving, copied, onCopy }: NoteToolbarActionsProps) => (
  <>
    {onSave && (
      <Button
        size="sm"
        variant="ghost"
        onClick={onSave}
        disabled={isSaving}
        className="h-8 gap-1 text-primary hover:bg-primary/5 hover:text-primary"
      >
        {isSaving ? <Loader2 className="h-4 w-4 animate-spin" /> : <Save className="h-4 w-4" />}
        Vista
      </Button>
    )}
    <Button
      size="sm"
      variant="outline"
      className={cn('ml-1 h-8 shrink-0 gap-1', copied && 'text-green-600 hover:text-green-600')}
      onClick={onCopy}
    >
      {copied ? <Check className="h-4 w-4" /> : <Copy className="h-4 w-4" />}
      {copied ? 'Afritað' : 'Afrita'}
    </Button>
  </>
);

/** The composer panel's template, review and visible note actions. */
export const NoteToolbar = ({ template, review, controls, actions }: NoteToolbarProps) => (
  <div data-testid="note-toolbar" className={noteToolbarClasses}>
    <div className={noteToolbarTemplateClasses}>{template}</div>
    {(review || controls || actions) && (
      <div className={noteToolbarActionsClasses}>
        {review}
        {controls && <NoteToolbarControls {...controls} />}
        {actions && <NoteSaveCopy {...actions} />}
      </div>
    )}
  </div>
);
